import {ReportField} from '../../Models/ReportField';

export enum ReportRowType {
    Table = 'table',
    Graph = 'graph',
}

export interface TableReportRow {
    type: ReportRowType.Table;
    fields: ReportField[];
}

export interface GraphReportRow {
    type: ReportRowType.Graph;
    x: ReportField;
    y: ReportField;
}

export type ReportRow = TableReportRow | GraphReportRow;

export interface TrendTemplate {
    title: string | null;
    rows: ReportRow[];
}

export interface ReportTemplate {
    trends: TrendTemplate[];
}
